/* SolisRestore scroll reveal (2026-11-01). Progressive: content is visible without this script; it only
   opts sections and product cards below the fold into a short fade-up as they enter the viewport.
   Skipped entirely for prefers-reduced-motion and browsers without IntersectionObserver. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var root = document.documentElement;
  root.classList.add('sr-motion');

  var SELECTOR = [
    'main > .shopify-section',
    'main .product-grid > li',
    'main .sr-prod-grid li',
    'main .sr-chair-finder__card'
  ].join(',');

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

  function arm(scope) {
    var fold = window.innerHeight;
    (scope || document).querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.hasAttribute('data-sr-reveal')) return;
      // Anything already on screen, the first section, and sticky/fixed UI stay as they are.
      if (el.matches('main > .shopify-section:first-child')) return;
      var rect = el.getBoundingClientRect();
      if (rect.top < fold || rect.height === 0) return;
      var pos = getComputedStyle(el).position;
      if (pos === 'fixed' || pos === 'sticky') return;
      if (el.parentElement && el.tagName === 'LI') {
        var i = Array.prototype.indexOf.call(el.parentElement.children, el) % 4;
        el.style.setProperty('--sr-reveal-delay', i * 70 + 'ms');
      }
      el.setAttribute('data-sr-reveal', '');
      io.observe(el);
    });
  }

  function start() {
    arm();
    // Grids that load more products (infinite scroll, filters) get the same treatment.
    var main = document.querySelector('main');
    if (main && 'MutationObserver' in window) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; arm(main); });
      }).observe(main, { childList: true, subtree: true });
    }
    // Safety net: never leave content hidden if an observer callback is missed (fast flicks, anchor jumps,
    // print, bfcache). Anything whose top is at or above the viewport bottom is revealed.
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; revealPassed(); });
    }, { passive: true });
    window.addEventListener('beforeprint', revealAll);
    window.addEventListener('pageshow', function (e) { if (e.persisted) revealAll(); });
    window.addEventListener('hashchange', revealAll);
  }

  function revealPassed() {
    var bottom = window.innerHeight;
    document.querySelectorAll('[data-sr-reveal]:not(.is-in)').forEach(function (el) {
      if (el.getBoundingClientRect().top < bottom) { el.classList.add('is-in'); io.unobserve(el); }
    });
  }

  function revealAll() {
    document.querySelectorAll('[data-sr-reveal]:not(.is-in)').forEach(function (el) { el.classList.add('is-in'); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
